import PropTypes from 'prop-types'

const MIN_WIDTH = 15

const ScoreBar = ({ percentage = MIN_WIDTH }) => {
  return (
    <div className="score-bar-wrapper">
      <span className="percentage-text">{`${percentage}%`}</span>
      <div
        className="score-bar"
        style={{ width: `${percentage > MIN_WIDTH ? percentage : MIN_WIDTH}%` }}
      />
    </div>
  )
}

ScoreBar.propTypes = {
  percentage: PropTypes.number,
}

export default ScoreBar
